import { escapeRegExp } from 'lodash';
import Highlighter from 'react-highlight-words';
import styled from 'styled-components';
import { ModelEntitySearchResponseItem } from '../../../../../../../../common/model/search/types';
import { BouColor } from '../../../../../../generic/global/bou-colors';
import { sanitizeSearch } from '../../shared';
import { SearchTheme } from '../../types';

interface Props {
  item: Pick<ModelEntitySearchResponseItem, 'created' | 'name' | 'query'>;
  theme: SearchTheme;
  grayStyle: boolean;
  creatable?: string;
  shouldWrap?: boolean;
}

export function NameBlock(props: Props) {
  const { item } = props;

  // for dynamically showing created stuff
  if (item.created) {
    return (
      <Root theme={props.theme} grayStyle={props.grayStyle}>
        <div>
          {props.creatable} {item.name}
        </div>
      </Root>
    );
  }

  // TODO ES: Add highlights for unmappable products in blanket search

  return (
    <Root theme={props.theme} grayStyle={props.grayStyle} shouldWrap={props.shouldWrap}>
      <Highlighter
        textToHighlight={item.name}
        searchWords={item.query && item.query.length > 1 ? [escapeRegExp(item.query)] : []}
        sanitize={sanitizeSearch}
        highlightStyle={{ backgroundColor: BouColor.TOOL_TEXT_HIGHLIGHT_YELLOW }}
      />
    </Root>
  );
}

const Root = styled.div<Pick<Props, 'theme' | 'grayStyle' | 'shouldWrap'>>`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: none;
  white-space: ${props => (props.shouldWrap ? 'normal' : 'nowrap')};
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => {
    if (!props.grayStyle) {
      if (props.theme === 'light') return BouColor.PLATFORM_TEXT_BLACK;
      return BouColor.PLATFORM_TEXT_WHITE;
    }
    return BouColor.PLATFORM_TEXT_GRAY;
  }};
`;
